var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',{staticClass:"center-map-on-user-btn pdgh- btn--link-dark",attrs:{"variant":"bare","title":_vm.title},on:{"click":_vm.pan}},[_c('Icon',{attrs:{"id":_vm.locationAvailable ? 'geolocation' : 'geolocation-unavailable',"scale":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }